// Offer prices supplied by the user on 2026-10-14; confirm in the quotation.
export const ASUS_GX10_OFFER_ID = "asus-gx10-october-2026";
export const ASUS_GX10_MODEL = "Ascent GX10";
export const ASUS_GX10_MEMORY = "128 GB unified memory";
export const ASUS_GX10_TERMS =
  "Hardware supply only. Prices exclude applicable taxes and delivery. Subject to stock availability.";

export const asusGx10Configurations = [
  { storage: "1 TB", priceRm: 38000 },
  { storage: "2 TB", priceRm: 46000 },
  { storage: "4 TB", priceRm: 49000 },
] as const;

export type AsusGx10Storage = (typeof asusGx10Configurations)[number]["storage"];

export function asusGx10QuotePath(storage: AsusGx10Storage): string {
  const params = new URLSearchParams({
    model: ASUS_GX10_MODEL,
    storage,
    quantity: "1",
    offer: ASUS_GX10_OFFER_ID,
  });
  return `/enterprise/dgx-spark-malaysia/enquiry/?${params.toString()}`;
}

export function asusGx10OfferSelection(model: string, storage: string, offerId: string | null) {
  if (model !== ASUS_GX10_MODEL || offerId !== ASUS_GX10_OFFER_ID) return undefined;
  return asusGx10Configurations.find((option) => option.storage === storage);
}

export function formatGx10Price(priceRm: number): string {
  return `RM${priceRm.toLocaleString("en-MY")}`;
}

export const ASUS_GX10_PRICE_LINE = `128 GB GX10 offer: ${asusGx10Configurations.map((option) => `${option.storage} ${formatGx10Price(option.priceRm)}`).join(" · ")}`;
export const ASUS_GX10_PRICE_ANSWER = `Our advertised 128 GB configurations are ${asusGx10Configurations.map((option) => `${formatGx10Price(option.priceRm)} for ${option.storage}`).join(", ")}, with a 1-year hardware warranty. ${ASUS_GX10_TERMS} Select the storage and quantity to request a quotation; we confirm the exact SKU, availability and final price before you purchase.`;

export function asusGx10Prefill(params: Pick<URLSearchParams, "get">) {
  if (params.get("model") !== ASUS_GX10_MODEL || params.get("offer") !== ASUS_GX10_OFFER_ID) return undefined;
  const option = asusGx10Configurations.find((item) => item.storage === params.get("storage"));
  const quantity = params.get("quantity") ?? "1";
  const validQuantity = /^\d+$/.test(quantity) && Number(quantity) >= 1 && Number(quantity) <= 9999;
  return { storage: option?.storage ?? "Advise me", quantity: validQuantity ? quantity : "1" };
}

export function appendAsusGx10OfferFields(body: FormData, model: string, storage: string, offerId: string | null): void {
  if (model !== ASUS_GX10_MODEL || offerId !== ASUS_GX10_OFFER_ID) return;
  const selection = asusGx10OfferSelection(model, storage, offerId);
  body.append("offer_id", ASUS_GX10_OFFER_ID);
  body.append("memory", ASUS_GX10_MEMORY);
  if (selection) body.append("advertised_unit_price_rm", String(selection.priceRm));
  body.append("hardware_warranty", "1 year");
  body.append("price_terms", ASUS_GX10_TERMS);
}
